import angular from 'angular'

angular.module('nominas.donaciones')
  .factory('NominasDonaciones', ['$api', '$schema', Service]);

function Service($api, $schema) {
  let NominasDonaciones = {};

  NominasDonaciones.get = function (ID_Empresa, ID_Nomina) {
    return $api.get('kendu/nominas/donaciones/get', {
      ID_Empresa: ID_Empresa,
      ID_Nomina: ID_Nomina,
    }).then(function (response) {
      return $schema(response, {
        Fecha: 'date',
        Fecha_Final: 'date',
        Fecha_Inicial: 'date',
        Fecha_Pago: 'date',
        Terminado: 'boolean',
        Registros: {
          Status: 'boolean',
          Saldo: 'number',
          Donaciones: 'number',
          Comision_Porcentaje: 'number',
          Subtotal: 'number',
          Comision: 'number',
          Total: 'number',
        },
        Servicios: {
          Fecha_Movimiento: 'date',
          Importe: 'number',
          Status: 'boolean',
        },
      });
    });
  };

  NominasDonaciones.save = function (data) {
    return $api.post('kendu/nominas/donaciones/save', {
      Data: data,
    }).then(function (response) {
      return $schema(response, {});
    });
  };

  return NominasDonaciones;
}



// WEBPACK FOOTER //
// ./src/nominas/donaciones/services/NominasDonaciones.js